import React, { useState, useEffect, useRef } from "react";
import Tabs, { Tab } from "common/layouts/Tabs";
import Help from "./Help";
import {
  LabelRetrieval,
  FilteringSettings,
  PeriodContext,
} from '../common';
import View from 'common/View';

const speedFacets = ({
  RttiLo = "0-10ms",
  RttiMd = "10-60ms",
  RttiHi = ">60ms",
}) => [
  {
    label: "All Internet Latencies",
    units: "%",
    fields: [
      {
        name: "global",
        label: "Acceleration",
        color: "var(--bta-color-strong)",
        area: true,
      },
    ],
    noDataMessage: "Not enough samples or no significant acceleration",
  },
  {
    label: `${RttiLo} Internet Latency`,
    units: "%",
    fields: [
      {
        name: "small",
        label: "Acceleration",
        color: "var(--bta-color-strong)",
        area: true,
      },
    ],
    noDataMessage: "Not enough samples or no significant acceleration",
  },
  {
    label: `${RttiMd} Internet Latency`,
    units: "%",
    fields: [
      {
        name: "medium",
        label: "Acceleration",
        color: "var(--bta-color-strong)",
        area: true,
      },
    ],
    noDataMessage: "Not enough samples or no significant acceleration",
  },
  {
    label: `${RttiHi} Internet Latency`,
    units: "%",
    fields: [
      {
        name: "large",
        label: "Acceleration",
        color: "var(--bta-color-strong)",
        area: true,
      },
    ],
    noDataMessage: "Not enough samples or no significant acceleration",
  },
];

export const TCPOComparison = ({ hours = 24 }) => {
  const [params, setParams] = useState({ hours });
  const onHoursChange = (hours) => setParams({ hours });
  return (
    <View title="TCP connections acceleration over time" Help={Help}>
          <LabelRetrieval>
            {(labels) => (
              <Tabs>
                <Tab label="DOWNLOAD" id="down" active={true}>
                  <FilteringSettings
                    direction="down"
                    type="acceleration"
                    {...params}
                    onHoursChange={onHoursChange}
                  >
                    {(result) => (
                      <PeriodContext facets={speedFacets(labels)} {...result} />
                    )}
                  </FilteringSettings>
                </Tab>
                <Tab label="UPLOAD" id="up">
                  <FilteringSettings
                    direction="up"
                    type="acceleration"
                    {...params}
                    onHoursChange={onHoursChange}
                  >
                    {(result) => (
                      <PeriodContext facets={speedFacets(labels)} {...result} />
                    )}
                  </FilteringSettings>
                </Tab>
              </Tabs>
            )}
          </LabelRetrieval>
    </View>
  );
};
